export function applyDocumentLocale(locale) {
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
}
export function changeLanguage(i18n, locale) {
  i18n.locale = locale;
  applyDocumentLocale(locale);
  localStorage.setItem('lang', locale);
  window.location.reload();
}
